import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=27f1e7f2&scoped=true&"
import script from "./CreateUser.vue?vue&type=script&lang=ts&"
export * from "./CreateUser.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUser.vue?vue&type=style&index=0&id=27f1e7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f1e7f2",
  null
  
)

export default component.exports